
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/contact-us" className="footer-link">Contact Us</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
        </div>
        <div className="footer-trademark">
          <p className="footer-disclaimer">
            This service analyzes publicly available data from Reddit. Usage is subject to <a href="https://redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer">Reddit's Terms of Service</a>.
          </p>
          <p>&copy; 2025 WizeHelper. This service is for analytical purposes only.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
